// extracted by mini-css-extract-plugin
module.exports = {"turtle":"Turtle_turtle__3hIVu","spin360":"Turtle_spin360__cP9KI"};